<template>
<div v-if = "catodicoPatrullajex">
  <div v-show = "imageFullscreen == false">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <h3 class="card-title">Datos del sistema de protección catódica</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="position-relative">
              <div class="row">
                <!---------------------- SISTEMA/METODO ---------------------->
                <div class="col-lg-6">
                  <label>Sistema</label>
                  <b-list-group>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      Sistema de protección catódica
                      <b-badge variant="primary" pill>✓</b-badge>
                    </b-list-group-item>
                    <b-list-group-item variant="light" class="py-0 d-flex justify-content-between align-items-center">
                      Rectificador
                    </b-list-group-item>
                    <b-list-group-item variant="light" class="py-0 d-flex justify-content-between align-items-center">
                      Juntas Dieléctricas
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <!---------------------- AREA/LOCACION/FECHA/USUARIO ---------------------->
                <div class="col-lg-6">
                  <label>&nbsp;</label>
                  <b-list-group>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      <b>Área:</b> Protección catódica
                    </b-list-group-item>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      <b>Locación:</b> {{metalocaciones[catodicoPatrullajex.identification.location].display_name}}
                    </b-list-group-item>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      <b>Fecha</b> {{catodicoPatrullajex.identification.date_start}} a {{catodicoPatrullajex.identification.date_end}}
                    </b-list-group-item>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      <b>Usuario</b> {{catodicoPatrullajex.username}}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
              <div class="row">
                <!---------------------- METODO ---------------------->
                <div class="col-lg-12">
                  <label>Método Utilizado</label>
                  <b-list-group>
                    <b-list-group-item variant="light" class="py-0 d-flex justify-content-between align-items-center">
                      <div>
                        NACE Standard TM0497-2012
                        <small>"Measurement Techniques Related to Criteria for Cathodic Protection on Underground of Submerged Metallic Piping Systems"</small>
                      </div>
                    </b-list-group-item>
                    <b-list-group-item class="py-0 d-flex justify-content-between align-items-center">
                      <div>
                        NACE Standard SP0169-2013
                        <small>"Control of External Corrosion on Underground of Submerged Metallic Piping Systems"</small>
                      </div>
                      <b-badge variant="primary" pill>✓</b-badge>
                    </b-list-group-item>
                    <b-list-group-item variant="light" class="py-0 d-flex justify-content-between align-items-center">
                      <div>
                        NACE Standard SP0286-2007 (formerly RP0286)
                        <small>"Electrical Isolation of Cathodically Protected Pipelines"</small>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
              <div class="row">
                <!---------------------- EQUIPOS ---------------------->
                <div class="col-lg-12" v-if="equipment">
                  <label>Equipo Utilizado</label>
                  <div class="list-group-horizontal d-flex flex-wrap">
                    <b-list-group-item class="py-0 flex-fill float-left" v-for = "(eq,j) in equipment"
                      v-bind:key="j">
                      {{eq.device_name}} [{{eq.device_serial}}]
                    </b-list-group-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!---------------------- CHART ---------------------->
      <div class="col-lg-6">
        <div ref="parentGrafico">
          <div ref="grafico" class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Inspección poste a poste</h3>
              </div>
              <div class="card-tools d-none d-xl-block d-lg-block">
                <a class="btn btn-sm btn-tool" @click="imageFullscreen = !imageFullscreen; componentType = 'graphic'">
                  <fa-icon :icon="imageFullscreen ? 'compress':'expand'" />
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="position-relative">
                <bar-chart :chart-data="chartdata" :options="chartoptions" :height="200" :plugins="chartplugins"></bar-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HistoricoPunto :catodico="selectedCatodico" v-on:ok="selectedCatodico = null" />
      <!---------------------- REGISTRO FOTOGRÁFICO ---------------------->
      <div class="col-lg-6">
        <div ref="parentImagenes">
          <div ref="imagenes" class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Registro fotográfico</h3>
              </div>
              <div class="card-tools d-none d-xl-block d-lg-block">
                <a class="btn btn-sm btn-tool" @click="imageFullscreen = !imageFullscreen; componentType = 'image'">
                  <fa-icon :icon="imageFullscreen ? 'compress':'expand'" />
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="position-relative">
                <b-carousel id="carousel" indicators controls :interval="0">
                  <b-carousel-slide v-for="(att, i) in attachments" :key = "i"
                    :img-src="att?att.url:''"
                  >{{att?att.pk:''}}</b-carousel-slide>
                </b-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!---------------------- TABLA ---------------------->
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <h3 class="card-title">Mediciones Flowline (mV DC vs CSE)</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="position-relative">
              <b-table small :striped="true" :items="tabledata" :fields="tablefields"></b-table>
            </div>
          </div>
        </div>
      </div>
      <!---------------------- OBS ---------------------->
      <div class="col-lg-6">
        <b-card no-body>
          <template v-slot:header>
            <div class="d-flex justify-content-between">
              <h3 class="card-title">&nbsp;</h3>
            </div>
          </template>
          <b-list-group flush>
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Observaciones</h5>
              </div>
              <p class="mb-1">{{catodicoPatrullajex.observations}}</p>
            </b-list-group-item>

            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Recomendaciones</h5>
              </div>
              <p class="mb-1">{{catodicoPatrullajex.recomendations}}</p>
            </b-list-group-item>

            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Formas de implementar las recomendaciones</h5>
              </div>
              <p class="mb-1">{{catodicoPatrullajex.implementation}}</p>
            </b-list-group-item>

          </b-list-group>
        </b-card>
      </div>
    </div>
  </div>
  <div class="expand" v-show = "imageFullscreen">
    <div class="col-lg-12 expandable" ref="parentFullscreen">
    </div>
  </div>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import BarChart from '../chart/BarChart.vue'
import Vue from 'vue'
import HistoricoPunto from './HistoricoPunto.vue'

export default {
  components: {
    BarChart,
    HistoricoPunto
  },
  data () {
    return {
      imageFullscreen: false,
      componentType: null,
      chartdata: {
        labels: [10, 10],
        datasets: [
          {
            label: 'data',
            backgroundColor: '#f87979',
            data: [10, 10]
          }
        ]
      },
      chartoptions: {
        elements: {
          line: {
            tension: 0
          }
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Progresiva'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'MVDC'
            },
            ticks: {
              beginAtZero: true,
              reverse: true,
              suggestedMin: -1600,
              mirror: true
            }
          }]
        },
        onClick: this.chartClick
      },
      chartplugins: [],
      metadata: {},
      metacatodico: {},
      catodicoPatrullajex: null,
      catodicos_on: [],
      catodicos_off: [],
      catodicos_natural: [],
      metalocaciones: {},
      equipment: [],
      tabledata: [],
      tablefields: [
        {
          key: '1',
          label: 'Progresiva',
          sortable: true
        },
        {
          key: '2',
          label: 'Pot. On',
          sortable: true
        },
        {
          key: '3',
          label: 'Pot. Off',
          sortable: true
        },
        {
          key: '4',
          label: 'Pot. Natural',
          sortable: true
        }
      ],
      attachments: [],
      selectedCatodico: null
    }
  },
  props: {
    catodicoPatrullaje: Object
  },
  watch: {
    catodicoPatrullaje (to, from) {
      this.loadCatodicos()
    },
    imageFullscreen (to, from) {
      if (to) {
        switch (this.componentType) {
          case 'image':
            this.$refs.parentFullscreen.appendChild(this.$refs.imagenes)
            break
          case 'graphic':
            this.$refs.parentFullscreen.appendChild(this.$refs.grafico)
        }
      } else {
        switch (this.componentType) {
          case 'image':
            this.$refs.parentImagenes.appendChild(this.$refs.imagenes)
            break
          case 'graphic':
            this.$refs.parentGrafico.appendChild(this.$refs.grafico)
        }
      }
    }
  },
  mounted () {
    var obj = this
    import('../../configuration/json/catodico_patrullaje.json').then(function (met) {
      obj.metadata = met
      import('../../configuration/json/catodico.json').then(function (met2) {
        obj.metacatodico = met2
        var metalocaciones = {}
        for (var i in met2.identification.children.location.choices) {
          var loc = met2.identification.children.location.choices[i]
          metalocaciones[loc.value] = { display_name: loc.display_name, choices: {} }
          for (var j in loc.choices) {
            metalocaciones[loc.value].choices[loc.choices[j].value] = loc.choices[j].display_name
          }
        }
        obj.$set(obj, 'metalocaciones', metalocaciones)
        obj.loadCatodicos()
      })
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadCatodicos () {
      var obj = this
      obj.get_db().then(function (db1) {
        db1.get(obj.$route.params.id).then(function (catodicoPatrullaje) {
          obj.catodicoPatrullajex = catodicoPatrullaje
          obj.get_db({ json: 'catodico' }).then(function (db2) {
            db2.find({
              selector: {
                'identification.location.flowline': {
                  '$eq': catodicoPatrullaje.identification.location
                },
                'identification.date': {
                  '$gte': catodicoPatrullaje.identification.date_start,
                  '$lte': catodicoPatrullaje.identification.date_end
                }
              }
            }).then(function (selection) {
              // selection.docs.sort(function (a, b) { return a.identification.location.progressive.localeCompare(b.identification.location.progressive) })
              // var elems = {}
              obj.catodicos_on = selection.docs
              var p2 = obj.loadCatodicosRelacionados(db2, 'pot_off', 'catodicos_off')
              var p3 = obj.loadCatodicosRelacionados(db2, 'pot_natural', 'catodicos_natural')
              Promise.all([p2, p3]).then(function () {
                // obj.loadPlot()
                obj.loadTable()
                obj.loadAttachments()
              })
            })
          })
        })
      })
      obj.imageFullscreen = false
      obj.componentType = null
    },
    loadCatodicosRelacionados (db, tipo, variable) {
      var obj = this
      var p = Promise.resolve(0)
      if (db.adapter === 'http') {
        var url = db.name + '/_design/app/_list/filter_latest/latest'
        p = Vue.http.get(url, {
          withCredentials: true,
          params: {
            start_key: JSON.stringify([tipo, obj.catodicoPatrullajex.identification.location, obj.catodicoPatrullajex.identification.date_end, {}]),
            end_key: JSON.stringify([tipo, obj.catodicoPatrullajex.identification.location]),
            inclusive_end: true,
            descending: true,
            limit: 1000
          }
        }).then(
          function (msj) {
            return msj.body
          },
          function (err) {
            console.log(err)
          }
        )
      } else {
        p = db.query('app/latest', {
          start_key: [tipo, obj.catodicoPatrullajex.identification.location, obj.catodicoPatrullajex.identification.date_end, {}],
          end_key: [tipo, obj.catodicoPatrullajex.identification.location],
          inclusive_end: true,
          descending: true,
          limit: 1000
        }).then(function (result) {
          return result.rows
        }).catch(function (err) {
          console.log('4', err)
        })
      }
      return p.then(function (cats) {
        var elems = {}
        for (var i in cats) {
          if (!(cats[i].key[3] in elems)) {
            elems[cats[i].key[3]] = cats[i].value
          }
        }
        obj.$set(obj, variable, elems)
      })
    },
    loadPlot () {
      var obj = this
      var data = []
      var labels = []
      var data850 = []
      var dataOff = []
      var dataNatural = []
      // var colors = []
      // var borders = []
      for (var i in obj.tabledata) {
        var row = obj.tabledata[i]
        /* var elem = {
          x: obj.metalocaciones[catx.identification.location.flowline].choices[catx.identification.location.progressive],
          y: catx.measurement.pot_on
        } */
        // var elem = parseInt(catx.measurement.pot_on)
        data.push({ x: row[0], y: row[2] })
        dataOff.push({ x: row[0], y: row[3] })
        dataNatural.push({ x: row[0], y: row[4] })
        data850.push(-850)
        labels.push(row[1])
      }

      // console.log(data)
      this.$set(this, 'chartdata', {
        datasets: [
          {
            type: 'line',
            label: 'Linea límite',
            fill: false,
            showLine: true,
            pointRadius: 0,
            borderWidth: 4,
            borderColor: 'rgb(255,192,0)',
            data: data850
          },
          {
            type: 'line',
            label: 'Potencial On',
            fill: false,
            showLine: true,
            pointRadius: 1,
            // pointHoverRadius: 10,
            // pointBackgroundColor: colors,
            // pointBackgroundColor: 'rgb(150,150,255)',
            // pointBorderColor: borders,
            borderWidth: 4,
            borderColor: 'rgb(0,176,80)',
            data: data
          },
          {
            type: 'line',
            label: 'Potencial Off',
            fill: false,
            showLine: true,
            pointRadius: 1,
            borderWidth: 4,
            borderColor: 'rgb(255,0,0)',
            data: dataOff
          },
          {
            type: 'line',
            label: 'Potencial Natural',
            fill: false,
            showLine: true,
            pointRadius: 1,
            borderWidth: 4,
            borderColor: 'rgb(128,100,162)',
            data: dataNatural
          }
        ],
        labels: labels
      })
    },
    loadTable () {
      var tabledata = {}
      var uniqueEquipment = {}
      var equipment = []
      for (var i in this.catodicos_on) {
        var cat = this.catodicos_on[i]
        tabledata[cat.identification.location.progressive] = [
          cat.identification.location.progressive,
          this.metalocaciones[cat.identification.location.flowline].choices[cat.identification.location.progressive],
          cat.measurement.pot_on,
          (cat.identification.location.progressive in this.catodicos_off) ? this.catodicos_off[cat.identification.location.progressive] : null,
          (cat.identification.location.progressive in this.catodicos_natural) ? this.catodicos_natural[cat.identification.location.progressive] : null,
          cat,
          this.metalocaciones[cat.identification.location.flowline].display_name
        ]
        if (cat.equipment) {
          for (var j in cat.equipment) {
            if (!(cat.equipment[j].device_serial in uniqueEquipment)) {
              uniqueEquipment[cat.equipment[j].device_serial] = true
              equipment.push(cat.equipment[j])
            }
          }
        }
        this.$set(this, 'equipment', equipment)
      }
      var sorted = Object.keys(tabledata).map(function (key) { return tabledata[key] })
      sorted.sort(function (a, b) { return a[0].localeCompare(b[0]) })
      this.$set(this, 'tabledata', sorted)
      this.loadPlot()
    },
    loadAttachments () {
      var obj = this
      obj.attachments = []
      var p = Promise.resolve(0)
      if (obj.catodicos_on) {
        obj.get_db({ json: 'catodico' }).then(function (db) {
          var indexes = []
          for (var i in obj.catodicos_on) {
            var cat = obj.catodicos_on[i]
            for (var j in cat.image || {}) {
              indexes.push({
                _id: cat._id,
                attachment: j,
                pk: obj.metalocaciones[cat.identification.location.flowline].choices[cat.identification.location.progressive]
              })
            }
          }
          // console.log(indexes)
          for (i in indexes) {
            p = p.then(function (i) {
              return function () {
                return db.getAttachment(indexes[i]._id, indexes[i].attachment, { attachments: true, binary: true })
                  .then(function (img) {
                  // console.log(indexes[i].pk)
                    obj.attachments.push({
                      url: window.URL.createObjectURL(img),
                      pk: indexes[i].pk
                    })
                  }).catch(function (err) {
                    console.log(err)
                  })
              }
            }(i))
          }
        })
      }
    },
    chartClick (event, array) {
      if (array && array.length) {
        this.selectedCatodico = { excuse: '', observations: '', recomendations: '', image: '' }
        this.$set(this, 'selectedCatodico', this.tabledata[parseInt(array[0]._index)][5])
        this.selectedCatodico.progressive = this.tabledata[parseInt(array[0]._index)][1]
        this.selectedCatodico.unity = this.tabledata[parseInt(array[0]._index)][6]
        /* this.loadPlot()
        this.loadTable() */
      }
    },
    imprimir () {
      var obj = this
      let routeData = this.$router.resolve({
        name: 'holdpoint',
        params: {
          typex: obj.$route.params.typex,
          json: obj.$route.params.json,
          id: this.inspection._id
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
.carousel-caption {
  background-color: rgba(0,0,0,0.5);
}

.expand {
  position: fixed;
  z-index: 999999;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: whitesmoke;
  display: flex;
  align-items: center;
  padding-bottom: 0 !important;
  cursor: default;
  margin: 0 auto;
  overflow: hidden;
}

.expandable {
  max-width: 85%;
  object-fit: contain;
  margin: 0 auto;
}
</style>
